import Swiper from 'swiper';

function init(parent) {
  const tabs = parent.querySelectorAll('.tabs__tab');
  const links = parent.querySelectorAll('.tabs__tab-link');
  const sections = parent.querySelectorAll('.tabs__section');

  const swiperElement = parent.querySelector('.tabs__tabs');
  const swiper = new Swiper(swiperElement, {
    direction: 'horizontal',
    slidesPerView: 'auto',
  });

  const updateTabsOverflowMode = () => {
    const containerWidth = swiperElement.offsetWidth;
    let tabsWidth = 0;
    let largestTab = 0;
    tabs.forEach((tab) => {
      const width = tab.offsetWidth;
      tabsWidth += width;
      if (width > largestTab) largestTab = width;
    });
    parent.style.setProperty('--tab-mobile-width', `${largestTab}px`);

    if (containerWidth < tabsWidth - 1) {
      parent.classList.add('is-mobile');
      swiper.enable();
    } else {
      parent.classList.remove('is-mobile');
      swiper.disable();
    }
  };
  updateTabsOverflowMode();
  window.addEventListener('resize', updateTabsOverflowMode);

  const activateTab = (tabLink) => {
    tabLink.setAttribute('aria-selected', true);
    tabLink.parentElement.classList.add('is-active');
  };

  const deactivateTab = (tabLink) => {
    tabLink.removeAttribute('aria-selected');
    tabLink.parentElement.classList.remove('is-active');
  };

  const gotoSectionByIndex = (newIdx, updateURL = true) => {
    links.forEach((link, idx) => {
      const tab = tabs[idx];
      const section = sections[idx];
      if (idx === newIdx) {
        activateTab(link);
        swiper.slideTo(idx);
        section.hidden = false;

        if (updateURL) {
          const anchor = link.getAttribute('href');
          if (anchor) history.replaceState({}, '', anchor);
        }
      } else {
        deactivateTab(link);
        section.hidden = true;
      }
    });
  };

  const gotoSectionByAnchor = (anchor, updateURL = true) => {
    history.replaceState({}, '', anchor);
    const id = anchor.split('#')[1];

    links.forEach((link, idx) => {
      if (link.getAttribute('href') === anchor) {
        activateTab(link);
        swiper.slideTo(idx);
      } else {
        deactivateTab(link);
      }
    });

    sections.forEach((section) => {
      if (section.id === id) {
        section.hidden = false;
      } else {
        section.hidden = true;
      }
    });
  };

  swiper.on('slideChange', (swiper) => {
    gotoSectionByIndex(swiper.realIndex);
  });

  links.forEach((link, idx) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();

      const anchor = link.getAttribute('href');
      if (anchor) {
        gotoSectionByAnchor(anchor);
      } else {
        gotoSectionByIndex(idx);
      }
    });
  });

  const anchor = window.location.hash;
  if (anchor) {
    const id = anchor.substring(1);
    if (document.getElementById(id)) {
      gotoSectionByAnchor(anchor);
    } else {
      gotoSectionByIndex(0, false);
    }
  } else {
    gotoSectionByIndex(0, false);
  }
}

export function tabs() {
  document.querySelectorAll('.tabs').forEach((parent) => init(parent));
}
